// source: kevbox/telemetry/v1/telemetry_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var kevbox_telemetry_v1_health_api_pb = require('../../../kevbox/telemetry/v1/health_api_pb.js');
goog.object.extend(proto, kevbox_telemetry_v1_health_api_pb);
goog.exportSymbol('proto.kevbox.telemetry.v1.CheckSystemHealthRequest', null, global);
goog.exportSymbol('proto.kevbox.telemetry.v1.CheckSystemHealthResponse', null, global);
goog.exportSymbol('proto.kevbox.telemetry.v1.ServiceHealth', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kevbox.telemetry.v1.CheckSystemHealthRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kevbox.telemetry.v1.CheckSystemHealthRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kevbox.telemetry.v1.CheckSystemHealthRequest.displayName = 'proto.kevbox.telemetry.v1.CheckSystemHealthRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.kevbox.telemetry.v1.CheckSystemHealthResponse.repeatedFields_, null);
};
goog.inherits(proto.kevbox.telemetry.v1.CheckSystemHealthResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kevbox.telemetry.v1.CheckSystemHealthResponse.displayName = 'proto.kevbox.telemetry.v1.CheckSystemHealthResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kevbox.telemetry.v1.ServiceHealth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.kevbox.telemetry.v1.ServiceHealth.repeatedFields_, null);
};
goog.inherits(proto.kevbox.telemetry.v1.ServiceHealth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kevbox.telemetry.v1.ServiceHealth.displayName = 'proto.kevbox.telemetry.v1.ServiceHealth';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.kevbox.telemetry.v1.CheckSystemHealthRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kevbox.telemetry.v1.CheckSystemHealthRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.CheckSystemHealthRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kevbox.telemetry.v1.CheckSystemHealthRequest}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kevbox.telemetry.v1.CheckSystemHealthRequest;
  return proto.kevbox.telemetry.v1.CheckSystemHealthRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kevbox.telemetry.v1.CheckSystemHealthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kevbox.telemetry.v1.CheckSystemHealthRequest}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kevbox.telemetry.v1.CheckSystemHealthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kevbox.telemetry.v1.CheckSystemHealthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.CheckSystemHealthRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.kevbox.telemetry.v1.CheckSystemHealthResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kevbox.telemetry.v1.CheckSystemHealthResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    systemStatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    healthStatusesList: jspb.Message.toObjectList(msg.getHealthStatusesList(),
    proto.kevbox.telemetry.v1.ServiceHealth.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kevbox.telemetry.v1.CheckSystemHealthResponse}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kevbox.telemetry.v1.CheckSystemHealthResponse;
  return proto.kevbox.telemetry.v1.CheckSystemHealthResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kevbox.telemetry.v1.CheckSystemHealthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kevbox.telemetry.v1.CheckSystemHealthResponse}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.kevbox.telemetry.v1.HealthStatus} */ (reader.readEnum());
      msg.setSystemStatus(value);
      break;
    case 2:
      var value = new proto.kevbox.telemetry.v1.ServiceHealth;
      reader.readMessage(value,proto.kevbox.telemetry.v1.ServiceHealth.deserializeBinaryFromReader);
      msg.addHealthStatuses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kevbox.telemetry.v1.CheckSystemHealthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kevbox.telemetry.v1.CheckSystemHealthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getHealthStatusesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.kevbox.telemetry.v1.ServiceHealth.serializeBinaryToWriter
    );
  }
};


/**
 * optional HealthStatus system_status = 1;
 * @return {!proto.kevbox.telemetry.v1.HealthStatus}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.prototype.getSystemStatus = function() {
  return /** @type {!proto.kevbox.telemetry.v1.HealthStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.kevbox.telemetry.v1.HealthStatus} value
 * @return {!proto.kevbox.telemetry.v1.CheckSystemHealthResponse} returns this
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.prototype.setSystemStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated ServiceHealth health_statuses = 2;
 * @return {!Array<!proto.kevbox.telemetry.v1.ServiceHealth>}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.prototype.getHealthStatusesList = function() {
  return /** @type{!Array<!proto.kevbox.telemetry.v1.ServiceHealth>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.kevbox.telemetry.v1.ServiceHealth, 2));
};


/**
 * @param {!Array<!proto.kevbox.telemetry.v1.ServiceHealth>} value
 * @return {!proto.kevbox.telemetry.v1.CheckSystemHealthResponse} returns this
*/
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.prototype.setHealthStatusesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.kevbox.telemetry.v1.ServiceHealth=} opt_value
 * @param {number=} opt_index
 * @return {!proto.kevbox.telemetry.v1.ServiceHealth}
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.prototype.addHealthStatuses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.kevbox.telemetry.v1.ServiceHealth, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.kevbox.telemetry.v1.CheckSystemHealthResponse} returns this
 */
proto.kevbox.telemetry.v1.CheckSystemHealthResponse.prototype.clearHealthStatusesList = function() {
  return this.setHealthStatusesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.kevbox.telemetry.v1.ServiceHealth.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kevbox.telemetry.v1.ServiceHealth.prototype.toObject = function(opt_includeInstance) {
  return proto.kevbox.telemetry.v1.ServiceHealth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kevbox.telemetry.v1.ServiceHealth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.ServiceHealth.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    serviceStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    checkResultsList: jspb.Message.toObjectList(msg.getCheckResultsList(),
    kevbox_telemetry_v1_health_api_pb.HealthCheckResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kevbox.telemetry.v1.ServiceHealth}
 */
proto.kevbox.telemetry.v1.ServiceHealth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kevbox.telemetry.v1.ServiceHealth;
  return proto.kevbox.telemetry.v1.ServiceHealth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kevbox.telemetry.v1.ServiceHealth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kevbox.telemetry.v1.ServiceHealth}
 */
proto.kevbox.telemetry.v1.ServiceHealth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceName(value);
      break;
    case 2:
      var value = /** @type {!proto.kevbox.telemetry.v1.HealthStatus} */ (reader.readEnum());
      msg.setServiceStatus(value);
      break;
    case 3:
      var value = new kevbox_telemetry_v1_health_api_pb.HealthCheckResult;
      reader.readMessage(value,kevbox_telemetry_v1_health_api_pb.HealthCheckResult.deserializeBinaryFromReader);
      msg.addCheckResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kevbox.telemetry.v1.ServiceHealth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kevbox.telemetry.v1.ServiceHealth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kevbox.telemetry.v1.ServiceHealth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kevbox.telemetry.v1.ServiceHealth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServiceStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCheckResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      kevbox_telemetry_v1_health_api_pb.HealthCheckResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional string service_name = 1;
 * @return {string}
 */
proto.kevbox.telemetry.v1.ServiceHealth.prototype.getServiceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.kevbox.telemetry.v1.ServiceHealth} returns this
 */
proto.kevbox.telemetry.v1.ServiceHealth.prototype.setServiceName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional HealthStatus service_status = 2;
 * @return {!proto.kevbox.telemetry.v1.HealthStatus}
 */
proto.kevbox.telemetry.v1.ServiceHealth.prototype.getServiceStatus = function() {
  return /** @type {!proto.kevbox.telemetry.v1.HealthStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.kevbox.telemetry.v1.HealthStatus} value
 * @return {!proto.kevbox.telemetry.v1.ServiceHealth} returns this
 */
proto.kevbox.telemetry.v1.ServiceHealth.prototype.setServiceStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated HealthCheckResult check_results = 3;
 * @return {!Array<!proto.kevbox.telemetry.v1.HealthCheckResult>}
 */
proto.kevbox.telemetry.v1.ServiceHealth.prototype.getCheckResultsList = function() {
  return /** @type{!Array<!proto.kevbox.telemetry.v1.HealthCheckResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, kevbox_telemetry_v1_health_api_pb.HealthCheckResult, 3));
};


/**
 * @param {!Array<!proto.kevbox.telemetry.v1.HealthCheckResult>} value
 * @return {!proto.kevbox.telemetry.v1.ServiceHealth} returns this
*/
proto.kevbox.telemetry.v1.ServiceHealth.prototype.setCheckResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.kevbox.telemetry.v1.HealthCheckResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.kevbox.telemetry.v1.HealthCheckResult}
 */
proto.kevbox.telemetry.v1.ServiceHealth.prototype.addCheckResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.kevbox.telemetry.v1.HealthCheckResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.kevbox.telemetry.v1.ServiceHealth} returns this
 */
proto.kevbox.telemetry.v1.ServiceHealth.prototype.clearCheckResultsList = function() {
  return this.setCheckResultsList([]);
};


goog.object.extend(exports, proto.kevbox.telemetry.v1);
